<!-- <app-header-image *ngIf="settings.header == 'image'"
    [backgroundImage]="'assets/images/others/locationSenegalAcueil.webp'" [bgImageAnimate]="true"
    [contentOffsetToTop]="true" [title]="'Louez un véhicule'" [desc]="'en quelques clics'" [isHomePage]="true"
    [fullscreen]="false" [menuSearch]="true">
</app-header-image> -->

<app-header-image
  [backgroundImage]="
    getHost.getHttpsImage() + 'images/categories/louez_vehicule.jpg'
  "
  [bgImageAnimate]="false"
  [contentOffsetToTop]="true"
  [menuSearch]="true"
  [title]="'Louez un véhicule'"
  [desc]="'en quelques clics'"
  [isHomePage]="false"
  [fullscreen]="false"
>
</app-header-image>

<app-menu-advantages></app-menu-advantages>

<div class="section mt-3 text-center">
    <h1 class="big-header">Louez des véhicules adaptés à vos besoins</h1>
    <span class="small-header">Louer n'importe quelle voiture, le modèle de votre choix</span>
</div>

<div class="section mt-3 px-3">
  <div class="px-3">
    <div class="theme-container">
      <div class="swiper-container h-100 carousel-outer" [swiper]="config2">
          <div fxLayout="row wrap" class="m-2">
              <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start start" style="font-weight:bolder">Nos Modèles de Véhicule</div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="end end">
                  <button class="prop-prev" mat-icon-button color="primary">
                      <mat-icon>chevron_left</mat-icon>
                  </button>
                  <button class="prop-next" mat-icon-button color="primary">
                      <mat-icon>chevron_right</mat-icon>
                  </button>
              </div>
          </div>

          <div class="swiper-wrapper h-100 m-2">
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('citadine')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car1.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Les citadines
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('utilitaire')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car2.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Les Utilitaires
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('crossover')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car3.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Les crossovers
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('cabriolet')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car4.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Les cabriolets et coupé
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('4x4')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car5.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Les 4X4
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('monospace')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car6.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Les monospaces
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('berline')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car7.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Les berlines
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
              <div class="swiper-slide">
                  <mat-card class="example-card" (click)="navigateModel('pickup')">
                      <img mat-card-image [src]="getHost.getHttpsImage() + 'modelescars/car8.jpg'" alt="Photo of a Shiba Inu">
                      <mat-card-content>
                        <h3 class="title-car">
                          Le Pickups
                        </h3>
                      </mat-card-content>                   
                    </mat-card>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-en-quelques-mots
  [hostServiceImage]="getHost.getHttpsImage()"
></app-en-quelques-mots> -->


<div class="section mt-3 " style="background-color: #efefee24;">
    <div class="px-3" >
        <div class="theme-container sect4-respo" fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" class="menu-items-carousel" fxLayoutAlign="center">
              <img [src]="getHost.getHttpsImage() + 'images/others/voitures4.png'" style="width:534px; margin:0px 35px" alt="about" class="mw-100 d-block" />
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                <h1 class='text-title'>Vous n'utilisez pas votre voiture tous les jours ?</h1>
                <h1 class="secondary-font primary-color mb-2">
                    Louez-la sur Siloka!
                </h1>
                <span style="font-size:16px">
                    <strong>INSCRIVEZ VOTRE VOITURE GRATUITEMENT</strong><br />
                    louez-la quand vous voulez et remboursez vos frais d'entretien. 
                    Rassurez-vous, c'est NSIA qui assure toutes les locations.
                </span>                   

                <div  fxLayout="row wrap" fxLayoutAlign="space-between center"  class="pt-3 btn-sect4-res" style="margin-top: 25px">
                    <a routerLink="/compte-utilisateur/mes-vehicules/liste-vehicule" mat-raised-button class="uppercase" color="primary"><mat-icon>car_rental</mat-icon> {{ 'Louer ma voiture' | translate }}</a>
                </div>
            </div>           
        </div>
    </div>
</div>


<div class="section default mt-3" style="background-color: #F2F4F5;">
  <div class="px-3">
    <div class="theme-container">
      <h1 class="section-title" style="font-family: inherit;">Louez une voiture à deux pas</h1>
      <p class="section-desc text-muted">
        <a
          mat-raised-button
          routerLink="/vehicules-disponibles"
          color="primary"
          class="uppercase"
          >Tous les véhicules disponibles</a
        >
      </p>
      <app-menu-items-carousel
        [menuItems]="menuItems"
        [carinput]="myInputMessage"
      ></app-menu-items-carousel>
      <div fxLayout="row" fxLayoutAlign="start center">
        <span  class="px-1">* Des véhicules de qualité mise à votre disposition. Les prix affichés sont susceptibles de varier.</span>
      </div>
    </div>
  </div>
</div>

<div class="section-x">
  <div class="px-3">
    <div class="theme-container">
      <div class="swiper-container h-100 carousel-outer sect5-respo" [swiper]="config4">
        <div fxLayout="row wrap"  >
            <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="start start" style="font-weight:bolder"></div>
            <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="end end">
                <button class="prop-prev" mat-icon-button color="primary">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button class="prop-next" mat-icon-button color="primary">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
        <div class="swiper-wrapper h-100 m-2">
          <div class="swiper-slide">
            <!-- <div class="px-3"> -->
            <div>
              <div class="theme-container" fxLayout="row wrap" >
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="p-2"> -->
                <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="center">
                    <img
                        [src]="getHost.getHttpsImage() + 'images/others/item1.png'"
                        alt="about about-img"
                        class="mw-100 d-block"
                        style="width:60%"
                    />
                </div>
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="menu-items-carousel context p-2"> -->
                <div fxFlex="100" fxFlex.gt-sm="50" class="menu-items-carousel context p-2">
                    <h1 class="text-title-1 ">La nouvelle manière</h1>
                    <h1 class="subtitle primary-color">
                        de louer une voiture
                    </h1> 
                    <br>
                        <span style="font-size: 16px;">Choisissez parmi des milliers de voitures disponibles auprès <br> de
                        particuliers et professionnels près de chez vous.</span> 
                    <br/>
                    <div  fxLayout="row wrap" fxLayoutAlign="space-between center"  class="pt-3 btn-sect5-res">
                        <!-- <img src="assets/images/others/signature.png" alt="signature"> -->
                        <a mat-raised-button routerLink="/about" color="primary" class="uppercase">Comment ça marche <mat-icon>arrow_circle_right</mat-icon></a>
                    </div>
                </div>
              </div>       
            </div>
          </div>
          <div class="swiper-slide">
            <!-- <div class="px-3"> -->
            <div>
              <div class="theme-container" fxLayout="row wrap" >
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="p-2"> -->
                <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="center">
                    <img
                        [src]="getHost.getHttpsImage() + 'images/others/item2.png'"
                        alt="about about-img"
                        class="mw-100 d-block"
                        style="width:60%"
                    />
                </div>
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="menu-items-carousel context p-2"> -->
                <div fxFlex="100" fxFlex.gt-sm="50" class="menu-items-carousel context p-2">
                    <h1 class="text-title-1">Voici la nouvelle manière</h1>
                    <h1 class="subtitle primary-color">
                        de louer une voiture
                    </h1> 
                    <br>
                    
                    <mat-icon color="primary" style="transform: translateY(5px);">
                        sentiment_satisfied</mat-icon> <span class="h3">Des prix par heure ou par jour</span> <br>              
                    <p>
                        Votre location sera assurée par NSA. Vous pouvez même ajouter <br> des
                        conducteurs additionnels sans frais supplémentaires.
                    </p>

                    <div  fxLayout="row wrap" fxLayoutAlign="space-between center"  class="pt-3 btn-sect5-res">
                        <!-- <img src="assets/images/others/signature.png" alt="signature"> -->
                        <a mat-raised-button routerLink="/about" color="primary" class="uppercase">Comment ça marche <mat-icon>arrow_circle_right</mat-icon></a>
                    </div>
                </div>
              </div>       
            </div>
          </div>
          <div class="swiper-slide">
            <!-- <div class="px-3"> -->
            <div>
              <div class="theme-container" fxLayout="row wrap" >
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="p-2"> -->
                <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="center">
                    <img
                        [src]="getHost.getHttpsImage() + 'images/others/item3.png'"
                        alt="about about-img"
                        class="mw-100 d-block"
                        style="width:60%"
                    />
                </div>
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="menu-items-carousel context p-2"> -->
                <div fxFlex="100" fxFlex.gt-sm="50" class="menu-items-carousel context p-2">
                    <h1 class="text-title-1">Voici la nouvelle manière</h1>
                    <h1 class="subtitle primary-color">
                        de louer une voiture
                    </h1> 
                    <br>
                    <mat-icon color="primary" style="transform: translateY(5px);">check_box</mat-icon> <span class="h3" color="primary">Pas d’agence, pas d’attente</span> <br>
                    <p>
                        Réservez une voiture près de chez vous instantanément, même <br> à la
                        dernière minute. Pas de file d’attente. Pas de paperasse.
                    </p>

                    <div  fxLayout="row wrap" fxLayoutAlign="space-between center"  class="pt-3 btn-sect5-res">
                        <!-- <img src="assets/images/others/signature.png" alt="signature"> -->
                        <a mat-raised-button routerLink="/about" color="primary" class="uppercase">Comment ça marche <mat-icon>arrow_circle_right</mat-icon></a>
                    </div>
                </div>
              </div>       
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-map-senegal></app-map-senegal> -->

<!-- actualites -->

<div class="section default mt-3 actu-no-responsive" style="background-color: #ffffff;">
  <div class="px-3">
    <div class="theme-container">
      <h1 class="title" style="font-family: inherit;text-align: center;">Actualités Récentes</h1>
      <div fxLayout="row wrap" fxLayoutAlign="center">
        
        <div fxFlex="100" fxFlex.gt-sm="25" *ngFor="let article of articles">
          <mat-card class="card-actuality"  style="margin:10px">            
            <img mat-card-image [src]="article.attachement !=null ? article.attachement.guid: defaultImage" alt="Photo of a Shiba Inu" style="width: -webkit-fill-available;">
            <mat-card-title style="margin-bottom: 0px !important;">{{article.post_title}}</mat-card-title>
            <mat-card-subtitle style="margin-top: -11px;margin-bottom: 7px !important;">{{article.post_modified | date:'mediumDate'}} .Par {{article.author.display_name}} . {{article.post_type}}</mat-card-subtitle>
            <mat-card-content datatype="html">
              {{article.post_content | slice:0:100}}

              <div style="margin-top: 10px;margin-bottom: 35px;color: cadetblue;"> 
                <a mat-button href="{{article.guid}}" style="float:left" target="_blank">En savoir plus <mat-icon>trending_flat</mat-icon></a>
                <button mat-icon-button style="float:right" mat-tooltip="commentaire">
                  {{article.comment_count}} <mat-icon>chat_bubble</mat-icon>
                </button>
              </div>

            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <!-- <div fxLayout="row" fxLayoutAlign="start center">
        <span  class="px-1">* Des véhicules de qualité mise à votre disposition. Les prix affichés sont susceptibles de varier.</span>
      </div> -->
    </div>
  </div>
</div>


<div class="section-x default mt-3 actu-responsive" style="background-color: #ffffff;">
  <div class="px-3">
    <div class="theme-container">
      <h1 class="title" style="font-family: inherit;text-align: center;">Actualités Récentes</h1>
      <div class="swiper-container h-100 carousel-outer" [swiper]="config">
        <div fxLayout="row wrap" class="m-2">
            <div fxFlex="100" fxLayoutAlign="end end">
                <button class="prop-prev" mat-icon-button color="primary">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button class="prop-next" mat-icon-button color="primary">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>

        <div class="swiper-wrapper h-100 m-2">
            <div class="swiper-slide" *ngFor="let article of articles">
              <mat-card class="card-actuality"  style="margin:10px">            
                <img mat-card-image [src]="article.attachement !=null ? article.attachement.guid: defaultImage" alt="Photo of a Shiba Inu" style="width: -webkit-fill-available;">
                <mat-card-title style="margin-bottom: 0px !important;">{{article.post_title}}</mat-card-title>
                <mat-card-subtitle style="margin-top: -11px;margin-bottom: 7px !important;">{{article.post_modified | date:'mediumDate'}} .Par {{article.author.display_name}} . {{article.post_type}}</mat-card-subtitle>
                <mat-card-content datatype="html">
                  {{article.post_content | slice:0:100}}
    
                  <div style="margin-top: 10px;margin-bottom: 35px;color: cadetblue;"> 
                    <a mat-button href="{{article.guid}}" style="float:left" target="_blank">En savoir plus <mat-icon>trending_flat</mat-icon></a>
                    <button mat-icon-button style="float:right" mat-tooltip="commentaire">
                      {{article.comment_count}} <mat-icon>chat_bubble</mat-icon>
                    </button>
                  </div>
    
                </mat-card-content>
              </mat-card>
            </div>
        </div>
    </div>
    </div>
  </div>
</div>


<!-- /actualites -->
<!-- <app-get-app-galsen
  [backgroundImage]="
    getHost.getHttpsImage() + 'images/others/homme_voiture.jpg'
  "
></app-get-app-galsen> -->

<!-- <app-our-services-galsen></app-our-services-galsen> -->

<!-- <app-question-insurance
  [hostServiceImage]="getHost.getHttpsImage()"
></app-question-insurance> -->

<app-testimonials-galsen></app-testimonials-galsen>
